import { render, staticRenderFns } from "./ImportRole.vue?vue&type=template&id=5220dbaf&scoped=true&"
import script from "./ImportRole.vue?vue&type=script&lang=js&"
export * from "./ImportRole.vue?vue&type=script&lang=js&"
import style0 from "./ImportRole.vue?vue&type=style&index=0&id=5220dbaf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220dbaf",
  null
  
)

export default component.exports